export default "__VITE_ASSET__4ec77841__"